import {AfterViewInit, Component, OnDestroy, QueryList, ViewChildren} from '@angular/core';
import {GeneralMeasurementModel} from "../../../../../../models/data-models/general-measurement-model";
import {NgModel} from "@angular/forms";
import {Subscription} from "rxjs";
import {ShareService} from "../../../../../../services/share.service";
import {ValidationService} from "../../../../../../services/validation.service";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'app-install-general-measurement',
  templateUrl: './install-general-measurement.component.html',
  styleUrls: ['./install-general-measurement.component.scss'],

})
export class InstallGeneralMeasurementComponent implements AfterViewInit, OnDestroy {
  public model: GeneralMeasurementModel;

  @ViewChildren(NgModel) inputs: QueryList<NgModel>;

  private readonly modelSub: Subscription;
  private inputSubscriptions: Subscription[] = [];

  constructor(
    public shareService: ShareService,
    public validationService: ValidationService
  ) {
    this.model = this.shareService.generalMeasurement || new GeneralMeasurementModel();
    this.modelSub = this.shareService.generalMeasurement$.subscribe((data) => {
      this.model = data || new GeneralMeasurementModel();
    });
  }

  ngAfterViewInit(): void {
    this.inputs.forEach(input => {
      this.inputSubscriptions.push(input.control.valueChanges.pipe(
        debounceTime(500)
      ).subscribe(() => {
        this.shareService.generalMeasurement = this.model;
      }));
    });

    // Subscribe to changes in the list of inputs
    // (it is called if some input is added or removed from the form/page,
    // for example, because of *ngIf condition changes)
    this.inputs.changes.subscribe(() => {
      // Unsubscribe from old subscriptions
      this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());

      // Subscribe to new inputs
      this.inputs.forEach(input => {
        this.inputSubscriptions.push(input.control.valueChanges.pipe(
          debounceTime(500)
        ).subscribe(() => {
          this.shareService.generalMeasurement = this.model;
        }));
      });
    });
  }

  ngOnDestroy(): void {
    this.inputSubscriptions.forEach(subscription => subscription.unsubscribe());
    if (this.modelSub) {
      this.modelSub.unsubscribe();
    }
  }
}
